import { render, staticRenderFns } from "./partcategories.vue?vue&type=template&id=9a4969b4&scoped=true&lang=pug"
import script from "./partcategories.vue?vue&type=script&lang=js"
export * from "./partcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4969b4",
  null
  
)

export default component.exports